import React, { Component } from "react";
import {
    DataGrid,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem,
    Lookup,
    StateStoring,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarDiatDs, criarContribuinteDs, criarReceitasDs, 
            criarSituacaoDividaDs, criarImovelDs } from "../../DataSources";

const localStorageKey = "cadastroDiatGridState";

let _diatCorrente = undefined;

export default class DiatBox extends Component {
    constructor() {
        super();
        this._gridInstance = React.createRef();
        this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    }

    onAtualizandoRow(e) {
        e.cancel = true;
        this.props.history.push("diat/editar/" + e.data.id);
    }

    render() {
        return (
            <React.Fragment>
                <div className={'content-block dx-card responsive-paddings'}>
                    <PaginaToolbar titulo="Dívida Ativa" novoCb={this.novaDiat.bind(this)}>
                        <DataGrid
                            ref={grid => this._gridInstance = grid}
                            dataSource={criarDiatDs()}
                            showBorders={true}
                            rowAlternationEnabled={true}
                            remoteOperations={true}
                            columnAutoWidth={true}
                            columnHidingEnabled={true}
                            focusedRowEnabled={true}
                            wordWrapEnabled={window.innerWidth < 800}
                            filterSyncEnabled={true}
                            onEditingStart={this.onAtualizandoRow}>
                            <FilterRow visible={true} />
                            <Editing allowDeleting={true} allowUpdating={true} mode />
                            <Column dataField={'id'} caption={"#"} allowEditing={false} />
                            <Column dataField={'prefeituraId'} caption={"Prefeitura"} visible={false}>
                                <FormItem visible={false}></FormItem>
                            </Column>
                            <Column dataField={'codigoDeOrigem'} caption={"Código de Origem"} />
                            <Column dataField={'contribuinteId'} caption={"Contribuinte"}>
                                <Lookup
                                    dataSource={criarContribuinteDs}
                                    valueExpr={"id"}
                                    displayExpr={"nome"} />
                            </Column>
                            <Column dataField={'historico'} caption={"Histórico"} />
                            <Column dataField={'receitaId'} caption={"Receita"}>
                                <Lookup
                                    dataSource={criarReceitasDs}
                                    valueExpr={"id"}
                                    displayExpr={"descricao"} />
                            </Column>
                            <Column dataField={'valorOriginal'} caption={"Valor Original"} />
                            <Column dataField={'vencimentoOriginal'} caption={"Vencimento Original"} />
                            <Column dataField={'dataDeTransferencia'} caption={"Data de Transferência"} />
                            <Column dataField={'dataDaUltimaCorrecao'} caption={"Data da Última Correção"} />
                            <Column dataField={'dataDePrescricao'} caption={"Data de Prescrição"} />
                            <Column dataField={'valorCorrigido'} caption={"Valor Corrigido"} />
                            <Column dataField={'multa'} caption={"Multa"} />
                            <Column dataField={'juros'} caption={"Juros"} />
                            <Column dataField={'situacaoId'} caption={"Situação"}>
                                <Lookup
                                    dataSource={criarSituacaoDividaDs}
                                    valueExpr={"id"}
                                    displayExpr={"nome"} />
                            </Column>
                            <Column dataField={'imovelId'} caption={"Imóvel"}>
                                <Lookup
                                    dataSource={criarImovelDs}
                                    valueExpr={"id"}
                                    displayExpr={"inscricaoCAA"} />
                            </Column>
                            <Column dataField={'pago'} caption={"Pago"} />
                            <Column dataField={'historico'} caption={"Histórico"} />

                            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                            />
                        </DataGrid>
                    </PaginaToolbar>
                </div>
            </React.Fragment>
        );
    }

    novaDiat() {
        let gridState = this._gridInstance.instance.state();
        localStorage.setItem(localStorageKey, JSON.stringify(gridState));
        this.props.history.push("diat/novo");
    }

}
